import { SharedTypes } from '../enum';
export const getSharedTypes = () => {
    return [SharedTypes.COMPANY, SharedTypes.SHARED];
};

export const getDefaultTypes = () => {
    return [
        { name: 'Active Only', value: true },
        { name: 'Inactive Only', value: false },
    ];
};
